import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardMedia from "@mui/material/CardMedia";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import TablePagination from "@mui/material/TablePagination";
import Typography from "@mui/material/Typography";
import ImageNotSupportedOutlinedIcon from "@mui/icons-material/ImageNotSupportedOutlined";
import TablePaginationActions from "../../../shared/components/Table/Actions";

const GRID_SIZE = { xs: 12, sm: 6, md: 4, lg: 3 };
const SKELETON_COUNT = 8;

const ComunicadoBannerList = ({
  listCB,
  isLoading = false,
  setComunicadoBanner,
  setPageNumber,
}) => {
  const handleChangePage = (event, newPage) => {
    setPageNumber(newPage);
  };

  const isEmpty = !isLoading && listCB.content.length === 0;

  return (
    <Box>
      {isEmpty ? (
        <Box
          sx={{
            py: 6,
            textAlign: "center",
            color: "text.secondary",
            border: 1,
            borderStyle: "dashed",
            borderColor: "divider",
            borderRadius: 2,
          }}
        >
          <ImageNotSupportedOutlinedIcon fontSize="large" />
          <Typography variant="body2" mt={1}>
            Nenhum banner cadastrado.
          </Typography>
        </Box>
      ) : (
        <Grid container spacing={2}>
          {isLoading
            ? Array.from({ length: SKELETON_COUNT }, (_, i) => (
                <Grid key={i} size={GRID_SIZE}>
                  <Skeleton
                    variant="rounded"
                    sx={{ width: "100%", height: "auto", aspectRatio: "16 / 9" }}
                  />
                </Grid>
              ))
            : listCB.content.map((cb) => (
                <Grid key={cb.codigo} size={GRID_SIZE}>
                  <Card
                    variant="outlined"
                    sx={{
                      transition: "box-shadow .2s, transform .2s",
                      "&:hover": { boxShadow: 4, transform: "translateY(-2px)" },
                    }}
                  >
                    <CardActionArea onClick={() => setComunicadoBanner(cb)}>
                      <CardMedia
                        component="img"
                        image={cb.urlBanner}
                        alt={`Banner ${cb.codigo}`}
                        loading="lazy"
                        sx={{
                          aspectRatio: "16 / 9",
                          objectFit: "contain",
                          bgcolor: "action.hover",
                        }}
                      />
                    </CardActionArea>
                  </Card>
                </Grid>
              ))}
        </Grid>
      )}

      {listCB.totalElements > 0 && (
        <TablePagination
          rowsPerPageOptions={[]}
          rowsPerPage={listCB.size || 0}
          component="div"
          count={listCB.totalElements}
          page={listCB.number}
          onPageChange={handleChangePage}
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} de ${count !== -1 ? `${count} registros` : `mais de ${to}`}`
          }
          ActionsComponent={TablePaginationActions}
          sx={{ mt: 2 }}
        />
      )}
    </Box>
  );
};

export default ComunicadoBannerList;
